// src/features/system/orchestrator/api/deviceAuthApi.ts
// ────────────────────────────────────────────────────────────────────────────
// TIER2 Device Auth API — typed client for BFF /device/* admin endpoints.
//
// Pending Tier 2 device codes are created by RFC 8628 Device Authorization
// Grant (PACDaemon, kiosk clients, FE-to-FE scope migrations) and must be
// approved by an authenticated admin through the DeviceApproverPanel.
// ────────────────────────────────────────────────────────────────────────────
import { bff } from '@/lib/http/bff';

/** A pending Tier 2 device code awaiting admin approval. */
export interface PendingDeviceCode {
  user_code:  string;
  device_id:  string;
  client_id:  string;
  scope:      string[];
  issued_at:  string;
  expires_at: string;
  /** Remaining seconds until the code expires. */
  ttl_sec:    number;
}

export interface PendingDeviceCodesResponse {
  items: PendingDeviceCode[];
}

export interface ApproveDeviceResponse {
  ok: boolean;
  device_id?: string;
  scope?: string[];
}

// ── Queries ──────────────────────────────────────────────────────────────

export const fetchPendingDeviceCodesApi = async (): Promise<PendingDeviceCode[]> => {
  const res = await bff.get<PendingDeviceCodesResponse>('/device/pending');
  return Array.isArray(res?.items) ? res.items : [];
};

// ── Mutations ────────────────────────────────────────────────────────────

export const approveDeviceCodeApi = (userCode: string): Promise<ApproveDeviceResponse> =>
  bff.post<ApproveDeviceResponse>('/device/authorize', { user_code: userCode });
